export default __webpack_public_path__ + "static/media/icon.a0bd2a69.png";